import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#027AFF",
      d: "M18.61 5.76c-1.135-1.941-2.682-3.01-4.36-3.01h-4.5c-1.678 0-3.225 1.069-4.36 3.01C4.257 7.7 3.75 9.968 3.75 12.5s.581 4.931 1.64 6.74c1.06 1.81 2.682 3.01 4.36 3.01h4.5c1.678 0 3.225-1.069 4.36-3.01 1.134-1.94 1.64-4.209 1.64-6.74s-.581-4.931-1.64-6.74m.121 5.99h-3c-.075-1.613-.384-3.16-.91-4.5h2.87c.572 1.256.956 2.813 1.04 4.5m-1.931-6h-2.69a8.4 8.4 0 0 0-1.126-1.5h1.266c.938 0 1.819.563 2.55 1.5m-2.55 15h-1.266a8.4 8.4 0 0 0 1.125-1.5H16.8c-.731.938-1.613 1.5-2.55 1.5m3.44-3h-2.868c.525-1.34.834-2.887.91-4.5h3c-.085 1.688-.47 3.244-1.041 4.5"
    }, null, -1)
  ])))
}
export default { render: render }